export default __webpack_public_path__ + "static/media/ic-gb-rounded.aea7d22b.svg";